import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Modules from "@/components/landing/Modules";
import Security from "@/components/landing/Security";
import Pricing from "@/components/landing/Pricing";
import Faq from "@/components/landing/Faq";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import ChatWidget from "@/components/ChatWidget";

export default function Home() {
  return (
    <div className="bg-[#0b131e] text-[#f1f5f9] min-h-screen selection:bg-[#E2C079]/30 selection:text-white relative overflow-hidden" data-testid="home-page">
      <Nav />
      <Hero />
      <Marquee />
      <Modules />
      <Security />
      <Pricing />
      <Faq />
      <Contact />
      <Footer />
      <ChatWidget />
    </div>
  );
}
